import { useReduxState } from 'hooks';
import { DisplayFormattedDate, User } from 'components/common';
import {
  BoxOverflowWrapper,
  BoxTable,
  BoxTableCell,
  BoxTableHeader,
  BoxTableRow
} from 'components/common/box';

import type { AnalyticsLoginEntry, UserWithBasicData } from 'shared-types';

type LoginEntry = Pick<
  AnalyticsLoginEntry,
  'authStrategy' | 'createdAt' | 'id' | 'ipAddress' | 'userAgent'
>;

interface LoginEntryWithDeviceAndUser extends LoginEntry {
  device: string;
  User?: UserWithBasicData;
}

interface Props {
  loginEntries: LoginEntryWithDeviceAndUser[];
  userColumn?: boolean;
}

const LoginHistoryTable = ({ loginEntries, userColumn = false }: Props) => {
  const { messages } = useReduxState();

  return (
    <BoxOverflowWrapper>
      <BoxTable>
        <BoxTableHeader>
          {userColumn && <BoxTableCell>{messages.commonUser}</BoxTableCell>}
          <BoxTableCell>{messages.commonTime}</BoxTableCell>
          <BoxTableCell>{messages.profileLoginType}</BoxTableCell>
          <BoxTableCell>{messages.profileLoginIpAddress}</BoxTableCell>
          <BoxTableCell>{messages.profileLoginBrowser}</BoxTableCell>
        </BoxTableHeader>

        {loginEntries?.map((entry) => (
          <BoxTableRow key={entry.id}>
            {userColumn && (
              <BoxTableCell>
                {entry.User ? (
                  <User enableProfileLink={true} user={entry.User} />
                ) : (
                  <>{messages.activitiesTitleDeleteUser}</>
                )}
              </BoxTableCell>
            )}

            <BoxTableCell label={messages.commonTime}>
              <DisplayFormattedDate
                date={entry.createdAt}
                dateFormat="dd.MM.y HH:mm"
              />
            </BoxTableCell>

            <BoxTableCell emptyValue="-" label={messages.profileLoginType}>
              {entry.User?.roles.includes('vuoadmin')
                ? 'Vuoadmin'
                : entry.User?.roles.includes('guest')
                ? messages.usersGuest
                : entry.authStrategy === 'local'
                ? messages.commonPassword
                : entry.authStrategy === 'totp'
                ? `${messages.commonPassword} ${messages.commonAnd} ` +
                  `${messages.authVerificationCode?.toLowerCase()}`
                : entry.authStrategy === 'totpBackup'
                ? `${messages.commonPassword} ${messages.commonAnd} ` +
                  `${messages.authTwoFactorBackupCode?.toLowerCase()}`
                : entry.authStrategy
                ? messages.commonSingleSignOn
                : null}
            </BoxTableCell>

            <BoxTableCell emptyValue="-" label={messages.profileLoginIpAddress}>
              {entry.ipAddress}
            </BoxTableCell>

            <BoxTableCell label={messages.profileLoginBrowser}>
              {entry.device}
            </BoxTableCell>
          </BoxTableRow>
        ))}
      </BoxTable>
    </BoxOverflowWrapper>
  );
};

export default LoginHistoryTable;
